export const Logo = ({ testId = "brand-logo", size = "h-9" }) => (
  <a href="/" data-testid={testId} className="inline-flex flex-col items-start gap-1.5 group">
    <img
      src="/logo.jpeg"
      alt="Keyscape Advisory Services LLP"
      className={`${size} w-auto rounded-md bg-white px-1.5 py-0.5 object-contain transition-transform duration-300 group-hover:scale-[1.03]`}
    />
    <span className="font-display text-xs md:text-sm tracking-wide text-[#F8F9FA] whitespace-nowrap leading-tight">
      Keyscape <span className="italic text-[#C8A97E]">Advisory Services</span> LLP
    </span>
    <span className="font-display italic text-[10px] md:text-[11px] text-[#C8A97E] tracking-wide" data-testid="logo-punchline">You Dream… We Facilitate it!</span>
  </a>
);
